import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  actionDescription: {
    defaultValue:
      'Ao excluir esta pasta, todos os dashboards contidos nela serão transferidos para a página principal. Esta ação não poderá ser desfeita.',
    key: 'delete-dashboard-folder-modal-actionDescription',
  },
  deletedMessage: {
    defaultValue: 'Pasta deletada com sucesso',
    key: 'delete-dashboard-folder-modal-deletedMessage',
  },
})
